/*
 *
 * PersonalData Actions
 *
 * @version 1.0.0
 * @author NEOSYN\user
 * @since 05-Nov-2024
 */

import { createRequestTypes, createAction, MakeRequest } from 'Store/actions/index'

export const actionTypes = {
  DO_CHANGE_FULL_NAME: '@@PersonalData/change_full_name',
  DO_CHANGE_FULL_NAME_VERIFY: '@@PersonalData/change_full_name_verify',
  DO_CHANGE_EMAIL: '@@PersonalData/change_email',
  DO_CHANGE_EMAIL_VERIFY: '@@PersonalData/change_email_verify',
  DO_CHANGE_PHONE: '@@PersonalData/change_phone',
  DO_CHANGE_PHONE_VERIFY: '@@PersonalData/change_phone_verify',
  DO_DELETE_PROFILE: '@@PersonalData/delete_profile',
  DO_DELETE_PROFILE_VERIFY: '@@PersonalData/delete_profile_verify',
  DO_CHANGE_FULL_NAME_RESEND_OTP: '@@PersonalData/change_full_name_resend_otp',
  DO_CHANGE_PHONE_RESEND_OTP: '@@PersonalData/change_phone_resend_otp',
  DO_DELETE_PROFILE_RESEND_OTP: '@@PersonalData/delete_profile_resend_otp',
  DO_CHANGE_EMAIL_RESEND_OTP: '@@PersonalData/change_email_resend_otp',
  DO_GET_PROFILE_DATA: '@@PersonalData/get_profile_data',
  DO_CHANGE_PASSWORD: '@@PersonalData/change_password',
  DO_GENERATE_OTP: '@@PersonalData/generate_otp',
  DO_RESET_IAM_DATA: '@@PersonalData/reset_iam_data',
  DO_UPDATE_CONSENTS: '@@PersonalData/update_consents',
  DO_GET_CONSENTS: '@@PersonalData/get_consents',
  DO_VALIDATE_FISCAL_CODE: '@@PersonalData/validate_fiscal_code',
  DO_UPDATE_FISCAL_CODE: '@@PersonalData/update_fiscal_code',
  DO_VALIDATE_ISP_EMAIL: '@@PersonalData/validate_isp_email',
  DO_VALIDATE_ISP_PHONE: '@@PersonalData/validate_isp_phone',
  DO_CHECK_CHANGE_EMAIL: '@@PersonalData/check_change_email',
  DO_CHANGE_EMAIL_DOUBLE_VERIFY: '@@PersonalData/change_email_double_verify',
  DO_CHECK_CHANGE_PHONE: '@@PersonalData/check_change_phone',
  DO_CHANGE_PHONE_DOUBLE_VERIFY: '@@PersonalData/change_phone_double_verify',
  DO_CHANGE_EMAIL_UCI: '@@PersonalData/change_email_uci',
  DO_CHANGE_EMAIL_VERIFY_WITH_EMAIL: '@@PersonalData/change_email_verify_with_email',
  DO_CHANGE_EMAIL_VERIFY_WITH_PHONE: '@@PersonalData/change_email_verify_with_phone',
  DO_CHANGE_PHONE_VERIFY_WITH_PHONE: '@@PersonalData/change_phone_verify_with_phone',
  DO_CHANGE_PHONE_VERIFY_WITH_EMAIL: '@@PersonalData/change_phone_verify_with_email',
  // @generator action:route:type
  ...createRequestTypes('@@PersonalData', 'CHANGE_FULL_NAME'),
  ...createRequestTypes('@@PersonalData', 'CHANGE_FULL_NAME_VERIFY'),
  ...createRequestTypes('@@PersonalData', 'CHANGE_EMAIL'),
  ...createRequestTypes('@@PersonalData', 'CHANGE_EMAIL_VERIFY'),
  ...createRequestTypes('@@PersonalData', 'CHANGE_PHONE'),
  ...createRequestTypes('@@PersonalData', 'CHANGE_PHONE_VERIFY'),
  ...createRequestTypes('@@PersonalData', 'DELETE_PROFILE'),
  ...createRequestTypes('@@PersonalData', 'DELETE_PROFILE_VERIFY'),
  ...createRequestTypes('@@PersonalData', 'CHANGE_FULL_NAME_RESEND_OTP'),
  ...createRequestTypes('@@PersonalData', 'CHANGE_PHONE_RESEND_OTP'),
  ...createRequestTypes('@@PersonalData', 'DELETE_PROFILE_RESEND_OTP'),
  ...createRequestTypes('@@PersonalData', 'CHANGE_EMAIL_RESEND_OTP'),
  ...createRequestTypes('@@PersonalData', 'GET_PROFILE_DATA'),
  ...createRequestTypes('@@PersonalData', 'CHANGE_PASSWORD'),
  ...createRequestTypes('@@PersonalData', 'GENERATE_OTP'),
  ...createRequestTypes('@@PersonalData', 'UPDATE_CONSENTS'),
  ...createRequestTypes('@@PersonalData', 'GET_CONSENTS'),
  ...createRequestTypes('@@PersonalData', 'VALIDATE_FISCAL_CODE'),
  ...createRequestTypes('@@PersonalData', 'DO_UPDATE_FISCAL_CODE'),
  ...createRequestTypes('@@PersonalData', 'VALIDATE_ISP_EMAIL'),
  ...createRequestTypes('@@PersonalData', 'VALIDATE_ISP_PHONE'),
  ...createRequestTypes('@@PersonalData', 'CHECK_CHANGE_EMAIL'),
  ...createRequestTypes('@@PersonalData', 'CHANGE_EMAIL_DOUBLE_VERIFY'),
  ...createRequestTypes('@@PersonalData', 'CHECK_CHANGE_PHONE'),
  ...createRequestTypes('@@PersonalData', 'CHANGE_PHONE_DOUBLE_VERIFY'),
  ...createRequestTypes('@@PersonalData', 'CHANGE_EMAIL_UCI'),
  ...createRequestTypes('@@PersonalData', 'CHANGE_EMAIL_VERIFY_WITH_EMAIL'),
  ...createRequestTypes('@@PersonalData', 'CHANGE_EMAIL_VERIFY_WITH_PHONE'),
  ...createRequestTypes('@@PersonalData', 'CHANGE_PHONE_VERIFY_WITH_PHONE'),
  ...createRequestTypes('@@PersonalData', 'CHANGE_PHONE_VERIFY_WITH_EMAIL')
  // @generator action:route:type:request
}

// ------------------------------------
// Actions
// ------------------------------------
// @generator action:route:request
/** @action request
* * Insert a description
* @name changeEmailDoubleVerify
* @return {object} - The action object
*/
export const changeEmailDoubleVerify = new MakeRequest('PersonalData', 'change_email_double_verify')
/** @action request
* * Insert a description
* @name checkChangeEmail
* @return {object} - The action object
*/
export const checkChangeEmail = new MakeRequest('PersonalData', 'check_change_email')
/** @action request
* * Insert a description
* @name checkChangePhone
* @return {object} - The action object
*/
export const checkChangePhone = new MakeRequest('PersonalData', 'check_change_phone')
/** @action request
* * Insert a description
* @name changePhoneDoubleVerify
* @return {object} - The action object
*/
export const changePhoneDoubleVerify = new MakeRequest('PersonalData', 'change_phone_double_verify')
/** @action request
* * Insert a description
* @name changeEmailUci
* @return {object} - The action object
*/
export const changeEmailUci = new MakeRequest('PersonalData', 'change_email_uci')
/** @action request
* * Insert a description
* @name changeEmailVerifyWithEmail
* @return {object} - The action object
*/
export const changeEmailVerifyWithEmail = new MakeRequest('PersonalData', 'change_email_verify_with_email')
/** @action request
* * Insert a description
* @name changeEmailVerifyWithPhone
* @return {object} - The action object
*/
export const changeEmailVerifyWithPhone = new MakeRequest('PersonalData', 'change_email_verify_with_phone')
/** @action request
* * Insert a description
* @name changePhoneVerifyWithPhone
* @return {object} - The action object
*/
export const changePhoneVerifyWithPhone = new MakeRequest('PersonalData', 'change_phone_verify_with_phone')
/** @action request
* * Insert a description
* @name changePhoneVerifyWithEmail
* @return {object} - The action object
*/
export const changePhoneVerifyWithEmail = new MakeRequest('PersonalData', 'change_phone_verify_with_email')
/** @action request
* * Insert a description
* @name validateIspPhone
* @return {object} - The action object
*/
export const validateIspPhone = new MakeRequest('PersonalData', 'validate_isp_phone')
/** @action request
* * Insert a description
* @name validateIspEmail
* @return {object} - The action object
*/
export const validateIspEmail = new MakeRequest('PersonalData', 'validate_isp_email')
/** @action request
* * Insert a description
* @name updateFiscalCode
* @return {object} - The action object
*/
export const updateFiscalCode = new MakeRequest('PersonalData', 'update_fiscal_code')
/** @action request
 * * Insert a description
 * @name validateFiscalCode
 * @return {object} - The action object
 */
export const validateFiscalCode = new MakeRequest('PersonalData', 'validate_fiscal_code')
/** @action request
 * * Insert a description
* @name updateConsents
* @return {object} - The action object
*/
export const updateConsents = new MakeRequest('PersonalData', 'update_consents')
/** @action request
 * * Insert a description
* @name getConsents
* @return {object} - The action object
*/
export const getConsents = new MakeRequest('PersonalData', 'get_consents')
/** @action request
* * Insert a description
* @name generateOtp
* @return {object} - The action object
*/
export const generateOtp = new MakeRequest('PersonalData', 'generate_otp')
/** @action request
 * * Insert a description
 * @name changePassword
 * @return {object} - The action object
 */
export const changePassword = new MakeRequest('PersonalData', 'change_password')
/** @action request
 * * Insert a description
 * @name getProfileData
 * @return {object} - The action object
 */
export const getProfileData = new MakeRequest('PersonalData', 'get_profile_data')
/** @action request
 * * Insert a description
 * @name changeEmailResendOtp
 * @return {object} - The action object
 */
export const changeEmailResendOtp = new MakeRequest('PersonalData', 'change_email_resend_otp')
/** @action request
 * * Insert a description
 * @name deleteProfileResendOtp
 * @return {object} - The action object
 */
export const deleteProfileResendOtp = new MakeRequest('PersonalData', 'delete_profile_resend_otp')
/** @action request
 * * Insert a description
 * @name changePhoneResendOtp
 * @return {object} - The action object
 */
export const changePhoneResendOtp = new MakeRequest('PersonalData', 'change_phone_resend_otp')
/** @action request
 * * Insert a description
 * @name changeFullNameResendOtp
 * @return {object} - The action object
 */
export const changeFullNameResendOtp = new MakeRequest('PersonalData', 'change_full_name_resend_otp')
/** @action request
 * * Insert a description
 * @name changeFullNameVerify
 * @return {object} - The action object
 */
export const changeFullNameVerify = new MakeRequest('PersonalData', 'change_full_name_verify')
/** @action request
 * * Insert a description
 * @name changeFullName
 * @return {object} - The action object
 */
export const changeFullName = new MakeRequest('PersonalData', 'change_full_name')
/** @action request
 * * Insert a description
 * @name deleteProfileVerify
 * @return {object} - The action object
 */
export const deleteProfileVerify = new MakeRequest('PersonalData', 'delete_profile_verify')
/** @action request
 * * Insert a description
 * @name deleteProfile
 * @return {object} - The action object
 */
export const deleteProfile = new MakeRequest('PersonalData', 'delete_profile')
/** @action request
 * * Insert a description
 * @name changePhoneVerify
 * @return {object} - The action object
 */
export const changePhoneVerify = new MakeRequest('PersonalData', 'change_phone_verify')
/** @action request
 * * Insert a description
 * @name changePhone
 * @return {object} - The action object
 */
export const changePhone = new MakeRequest('PersonalData', 'change_phone')
/** @action request
 * * Insert a description
 * @name changeEmailVerify
 * @return {object} - The action object
 */
export const changeEmailVerify = new MakeRequest('PersonalData', 'change_email_verify')
/** @action request
 * * Insert a description
 * @name changeEmail
 * @return {object} - The action object
 */
export const changeEmail = new MakeRequest('PersonalData', 'change_email')
// @generator action:route
/** @action
* * Insert a description
* @name ChangeEmailDoubleVerify
* @return {object} - The payload object
*/
export const doChangeEmailDoubleVerify = payload => createAction(actionTypes.DO_CHANGE_EMAIL_DOUBLE_VERIFY, { payload, isSca: true })
/** @action
* * Insert a description
* @name CheckChangeEmail
* @return {object} - The payload object
*/
export const doCheckChangeEmail = payload => createAction(actionTypes.DO_CHECK_CHANGE_EMAIL, { payload })
/** @action
* * Insert a description
* @name CheckChangePhone
* @return {object} - The payload object
*/
export const doCheckChangePhone = payload => createAction(actionTypes.DO_CHECK_CHANGE_PHONE, { payload })
/** @action
* * Insert a description
* @name ChangePhoneDoubleVerify
* @return {object} - The payload object
*/
export const doChangePhoneDoubleVerify = payload => createAction(actionTypes.DO_CHANGE_PHONE_DOUBLE_VERIFY, { payload, isSca: true })
/** @action
* * Insert a description
* @name ChangeEmailUci
* @return {object} - The payload object
*/
export const doChangeEmailUci = payload => createAction(actionTypes.DO_CHANGE_EMAIL_UCI, { payload })
/** @action
 * * Insert a description
 * @name ChangeEmailVerifyWithEmail
 * @return {object} - The payload object
 */
export const doChangeEmailVerifyWithEmail = payload => createAction(actionTypes.DO_CHANGE_EMAIL_VERIFY_WITH_EMAIL, { payload, isSca: true })
/** @action
 * * Insert a description
 * @name changeEmailVerifyWithPhone
 * @return {object} - The payload object
 */
export const doChangeEmailVerifyWithPhone = (payload) => createAction(actionTypes.DO_CHANGE_EMAIL_VERIFY_WITH_PHONE, { payload, isSca: true })
/** @action
 * * Insert a description
 * @name ChangePhoneVerifyWithPhone
 * @return {object} - The payload object
 */
export const doChangePhoneVerifyWithPhone = (payload) => createAction(actionTypes.DO_CHANGE_PHONE_VERIFY_WITH_PHONE, { payload, isSca: true })
/** @action
 * * Insert a description
 * @name ChangePhoneVerifyWithEmail
 * @return {object} - The payload object
 */
export const doChangePhoneVerifyWithEmail = (payload) => createAction(actionTypes.DO_CHANGE_PHONE_VERIFY_WITH_EMAIL, { payload, isSca: true })
// @generator action:route
/** @action
* * Insert a description
* @name ValidateIspPhone
* @return {object} - The payload object
*/
export const doValidateIspPhone = payload => createAction(actionTypes.DO_VALIDATE_ISP_PHONE, { payload })
/** @action
* * Insert a description
* @name ValidateIspEmail
* @return {object} - The payload object
*/
export const doValidateIspEmail = payload => createAction(actionTypes.DO_VALIDATE_ISP_EMAIL, { payload })
/** @action
* * Insert a description
* @name ValidateFiscalCode
* @return {object} - The payload object
*/
export const doValidateFiscalCode = payload => createAction(actionTypes.DO_VALIDATE_FISCAL_CODE, { payload })
/** @action
* * Insert a description
* @name UpdateFiscalCode
* @return {object} - The payload object
*/
export const doUpdateFiscalCode = payload => createAction(actionTypes.DO_UPDATE_FISCAL_CODE, { payload })
/** @action
* * Insert a description
* @name ResetIaMdata
* @return {object} - The payload object
*/
export const doResetIAMdata = payload => createAction(actionTypes.DO_RESET_IAM_DATA, { payload })
/** @action
* * Insert a description
* @name GenerateOtp
* @return {object} - The payload object
*/
export const doGenerateOtp = payload => createAction(actionTypes.DO_GENERATE_OTP, { payload })
/** @action
 * * Insert a description
 * @name ChangePassword
 * @return {object} - The payload object
 */
export const doChangePassword = (payload) => createAction(actionTypes.DO_CHANGE_PASSWORD, { payload, isSca: true })
/** @action
 * * Insert a description
 * @name GetProfileData
 * @return {object} - The payload object
 */
export const doGetProfileData = (payload) => createAction(actionTypes.DO_GET_PROFILE_DATA, { payload })
/** @action
 * * Insert a description
 * @name ChangeEmailResendOtp
 * @return {object} - The payload object
 */
export const doChangeEmailResendOtp = (payload) => createAction(actionTypes.DO_CHANGE_EMAIL_RESEND_OTP, { payload })
/** @action
 * * Insert a description
 * @name DeleteProfileResendOtp
 * @return {object} - The payload object
 */
export const doDeleteProfileResendOtp = (payload) =>
  createAction(actionTypes.DO_DELETE_PROFILE_RESEND_OTP, { payload })
/** @action
 * * Insert a description
 * @name ChangePhoneResendOtp
 * @return {object} - The payload object
 */
export const doChangePhoneResendOtp = (payload) => createAction(actionTypes.DO_CHANGE_PHONE_RESEND_OTP, { payload })
/** @action
 * * Insert a description
 * @name ChangeFullNameResendOtp
 * @return {object} - The payload object
 */
export const doChangeFullNameResendOtp = (payload) =>
  createAction(actionTypes.DO_CHANGE_FULL_NAME_RESEND_OTP, { payload })
/** @action
 * * Insert a description
 * @name ChangeFullNameVerify
 * @return {object} - The payload object
 */
export const doChangeFullNameVerify = (payload) => createAction(actionTypes.DO_CHANGE_FULL_NAME_VERIFY, { payload })
/** @action
 * * Insert a description
 * @name ChangeFullName
 * @return {object} - The payload object
 */
export const doChangeFullName = (payload) => createAction(actionTypes.DO_CHANGE_FULL_NAME, { payload })
/** @action
 * * Insert a description
 * @name DeleteProfileVerify
 * @return {object} - The payload object
 */
export const doDeleteProfileVerify = (payload) => createAction(actionTypes.DO_DELETE_PROFILE_VERIFY, { payload })
/** @action
 * * Insert a description
 * @name DeleteProfile
 * @return {object} - The payload object
 */
export const doDeleteProfile = (payload) => createAction(actionTypes.DO_DELETE_PROFILE, { payload })
/** @action
 * * Insert a description
 * @name ChangePhoneVerify
 * @return {object} - The payload object
 */
export const doChangePhoneVerify = (payload) => createAction(actionTypes.DO_CHANGE_PHONE_VERIFY, { payload })
/** @action
 * * Insert a description
 * @name ChangePhone
 * @return {object} - The payload object
 */
export const doChangePhone = (payload) => createAction(actionTypes.DO_CHANGE_PHONE, { payload })
/** @action
 * * Insert a description
 * @name ChangeEmailVerify
 * @return {object} - The payload object
 */
export const doChangeEmailVerify = (payload) => createAction(actionTypes.DO_CHANGE_EMAIL_VERIFY, { payload })
/** @action
 * * Insert a description
 * @name ChangeEmail
 * @return {object} - The payload object
 */
export const doChangeEmail = (payload) => createAction(actionTypes.DO_CHANGE_EMAIL, { payload })
/** @action
 * * Insert a description
 * @name UpdateConsents
 * @return {object} - The payload object
 */
export const doUpdateConsents = (payload) => createAction(actionTypes.DO_UPDATE_CONSENTS, { payload })
/** @action
 * * Insert a description
 * @name GetConsents
 * @return {object} - The payload object
 */
export const doGetConsents = () => createAction(actionTypes.DO_GET_CONSENTS)
